import React, {useRef, useState, useEffect} from "react";
import styles from "./InfoItem.module.css";
import classNames from "classnames"
import {useDispatch, useSelector} from "react-redux";
import {Button, Checkbox, Col, message, Row, Switch} from 'antd'

export default function InfoItem(props) {
    const dispatch = useDispatch();
    const [confirmInfo, setConfirmInfo] = useState({})
    const [messageApi, contextHolder] = message.useMessage();


    return <tr
        className={styles.tr1}
    >
        <td
            className={styles.td1}
        >{props.index}
        </td>
        <td
            className={styles.td1}
        >{props.index}
        </td>
        <td
            className={styles.td1}
        >{props.index}
        </td>
        <td
            className={styles.td1}
        >{props.index}
        </td>
        <td
            className={styles.td1}
        >{props.index}
        </td>
        <td
            className={styles.td1}
        >
            <Switch
                checked={props.checkedStatus}
                onChange={(checked) => {
                }}
                checkedChildren="开"
                unCheckedChildren="关"
                // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}
                style={{marginLeft: 10, marginRight: 10}}
            />

        </td>
        <td
            className={styles.td1}
        >{props.index}
        </td>
        <td
            className={styles.td1}
        >
            <Button
                color="primary"
                variant="link"
                onClick={() => {
                    props.editMethod(props.item);
                }}
            >
                编辑
            </Button>
            <Button
                color="primary"
                variant="link"
                onClick={() => {
                    props.editMethod(props.item);
                }}
            >
                查看
            </Button>
        </td>

        {contextHolder}
    </tr>
}
// export default PaymentInfoList;

